// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Fade } from '@mui/material';

// TODO: Import MUI icon

// Import context
import { } from '../Common/Context';

// TODO: Import custom component
import BoxImage from '../Common/BoxImage';

import FabArrowButton from './FabArrowButton';

const BoxSlide = () => {
    // TODO: Define useContext

    // TODO: Define variable
    const refBoxSlide = React.useRef(null);

    const [marginTop, setMarginTop] = React.useState(0);

    const [showFab, setShowFab] = React.useState(true);
    const [BoxNewsY, setBoxNewsY] = React.useState(0);

    const images = React.useMemo(() => [
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_04.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_01.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_02.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_03.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_05.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_06.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_07.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_08.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20260520_09.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20241219145158.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20250523154713.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide202507.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20250703200903.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20250703212154.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20240305.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20240308.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20240903164319.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20241106114647.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20241219164101.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20230423.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20230601180435.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20230702103905.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20230918173916.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20231017153848.jpg',
        'https://www.pohtyh.edu.hk/Files/Home/Slide20231213.jpg',
    ], []);
    const fadeInterval = 2500;
    const [showedIndex, setShowedIndex] = React.useState(0);

    // TODO: Define event
    React.useEffect(() => {
        const interval = setInterval(() => { setShowedIndex(prev => (prev + 1) % images.length) }, fadeInterval);
        return () => clearInterval(interval);
    }, [images.length]);

    const handleResizeAndScroll = () => {
        const componentTop_BoxName = document.getElementById('Top_BoxName');
        const componentTop_BoxMenu = document.getElementById('Top_BoxMenu');
        if (componentTop_BoxName && componentTop_BoxMenu) {
            const componentHeight = componentTop_BoxName.offsetHeight + componentTop_BoxMenu.offsetHeight;
            setMarginTop(componentHeight);
        }

        if (refBoxSlide.current) {
            const boxRect = refBoxSlide.current.getBoundingClientRect();

            setBoxNewsY(
                boxRect.bottom +
                window.scrollY -
                componentTop_BoxName.offsetHeight -
                componentTop_BoxMenu.offsetHeight
            );

            setShowFab(boxRect.bottom > window.innerHeight);
        }
    };

    React.useEffect(() => {
        handleResizeAndScroll();
        window.addEventListener('resize', handleResizeAndScroll);
        window.addEventListener('scroll', handleResizeAndScroll);
        return () => {
            window.removeEventListener('resize', handleResizeAndScroll);
            window.removeEventListener('scroll', handleResizeAndScroll);
        };
    }, []);

    // TODO: Return component
    return (
        <Box
            id="Home_BoxSlide"
            sx={{
                height: `calc(100vw * 4 / 6)`,
                mt: `${marginTop}px`,
                position: 'relative',
                width: 1,
            }}
            ref={refBoxSlide}
        >
            {showFab && <FabArrowButton scrollToY={BoxNewsY} />}
            {images.map((image, i) => (
                <Fade in={i === showedIndex} key={i} timeout={{ enter: 1000, exit: 1000 }}>
                    <Box>
                        <BoxImage
                            src={image}
                            sx={{ aspectRatio: 'auto', height: 1, objectFit: 'cover', position: 'absolute', width: 1, }}
                            sxSkeleton={{ aspectRatio: 'auto', height: 1, position: 'absolute', width: 1, }}
                        />
                    </Box>
                </Fade>
            ))}
        </Box>
    );
};
export default BoxSlide;